import script from "./ReunionRegistrationRecovery.vue?vue&type=script&setup=true&lang=js"
export * from "./ReunionRegistrationRecovery.vue?vue&type=script&setup=true&lang=js"

import "./ReunionRegistrationRecovery.vue?vue&type=style&index=0&id=b1b21f44&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b1b21f44"]])

export default __exports__